import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchField"]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  handleKeydown(event) {
    // Only focus if "/" is pressed and we're not already in an input/textarea/select
    if (event.key === "/" && !this.isInInputField(event.target)) {
      event.preventDefault()
      if (this.hasSearchFieldTarget) {
        this.searchFieldTarget.focus()
        this.searchFieldTarget.select()
      }
    }
  }

  isInInputField(element) {
    const tagName = element.tagName.toLowerCase()
    return tagName === "input" || tagName === "textarea" || tagName === "select" || element.isContentEditable
  }
} 